
import "/home/node/app/src/components/Chatbot/CardMessage/index.less?modules";
export default {"picture": `picture-FCW-V_vU`,"content": `content-H2EJD2Oi`,"footer": `footer-yyrXz1FM`,"cardContainer": `cardContainer-SeDga1Wd`,"header": `header-V5OuwlLB`,"title": `title-gL5u2pQ6`}
